import AddModal, { type IAddModalProps } from '@/components/AddModal/index.jsx';
import { useModal } from '@ebay/nice-modal-react';
import { memo } from 'react';
import isEqual from 'react-fast-compare';
import { planDetailEvent } from '../../utils/event.js';

function Add({
  planId,
  date,
}: {
  planId: string;
  date: string;

  id: string;
}) {
  const addModal = useModal(AddModal);
  return (
    <article
      className=' px-5 py-4   '
      onClick={() => {
        addModal.show({
          planId,
          date,
          onSuccess: () => {
            planDetailEvent.emit('requestRefresh');
          },
        } satisfies IAddModalProps);
      }}
    >
      <div className='flex items-start     '>
        <div
          className={
            'w-12 h-6 flex shrink-0 justify-center items-center rounded-[14px] bg-cover bg-center '
          }
        >
          <i className={'ic-outline text-gray-400 text-2xl md-add scale-110'} />
        </div>
        <div className='ml-[18px] flex-grow '>
          <span className='text-base font-semibold block text-gray-400'>
            添加活动
          </span>
        </div>
      </div>
    </article>
  );
}

export default memo(Add, isEqual);
